import { Routes } from '@angular/router';

import { AfterSalesTabsetComponent } from './content/after-sales/after-sales-tabset.component';
import { ApprovalComponent } from './content/approval/approval.component';
import { FieldMasterDataComponent } from './content/field-master-data/field-master-data.component';
import { RecourseBookingTabsetComponent } from './content/recourse-booking/recourse-booking-tabset.component';
import { RecourseCampaignComponent } from './content/recourse-campaign/recourse-campaign.component';
//import { RecourseClaimComponent } from './content/recourse-claim/recourse-claim.component';
import { AccessDeniedComponent } from './shared/access-denied/access-denied.component';
import { afterSalesGuardCanActivate } from './shared/router-guard/after-sales.guard';
import {
  recourseBookingGuardCanActivate,
  recourseBookingGuardCanDeactivate,
} from './shared/router-guard/recourse-booking.guard';
import { recourseCampaignGuardCanDeactivate } from './shared/router-guard/recourse-campaign.guard';

export const APP_ROUTES: Routes = [
  { path: 'recourseBooking', redirectTo: '/recourseBooking/overview', pathMatch: 'full' },
  {
    path: 'recourseBooking/:tabId',
    component: RecourseBookingTabsetComponent,
    canActivate: [recourseBookingGuardCanActivate],
    canDeactivate: [recourseBookingGuardCanDeactivate],
  },
  {
    path: 'recourseBooking/:tabId/:id',
    component: RecourseBookingTabsetComponent,
    canActivate: [recourseBookingGuardCanActivate],
    canDeactivate: [recourseBookingGuardCanDeactivate],
  },
  {
    path: 'recourseCampaign',
    component: RecourseCampaignComponent,
    canDeactivate: [recourseCampaignGuardCanDeactivate],
  },
  { path: 'approval', component: ApprovalComponent },
  { path: 'afterSales/tabs', redirectTo: '/afterSales/tabs/overview', pathMatch: 'full' },
  { path: 'afterSales/tabs/:tabId', component: AfterSalesTabsetComponent, canActivate: [afterSalesGuardCanActivate] },
  {
    path: 'afterSales/tabs/:tabId/:id',
    component: AfterSalesTabsetComponent,
    canActivate: [afterSalesGuardCanActivate],
  },
  // { path: 'claimRecourse', component: RecourseClaimComponent }, // Temporary turned off
  { path: 'fieldMasterData', redirectTo: '/fieldMasterData/partsAgreements', pathMatch: 'full' },
  { path: 'fieldMasterData/:tabId', component: FieldMasterDataComponent },
  { path: '403', component: AccessDeniedComponent },
  { path: '**', redirectTo: '/recourseBooking/overview', pathMatch: 'full' },
  { path: '', redirectTo: '/recourseBooking/overview', pathMatch: 'full' },
];
